import { render, staticRenderFns } from "./consumableBorrow.vue?vue&type=template&id=0615193c&scoped=true"
import script from "./consumableBorrow.vue?vue&type=script&lang=js"
export * from "./consumableBorrow.vue?vue&type=script&lang=js"
import style0 from "./consumableBorrow.vue?vue&type=style&index=0&id=0615193c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0615193c",
  null
  
)

export default component.exports